import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IRequestAccessForContentParams {
    contentIdentifier: String;
    contentType: String;
}

export interface IRequestAccessForContentResult {
}

export class RequestAccessForContentRequest extends Request<IRequestAccessForContentParams, IRequestAccessForContentResult> {
  constructor(params: IRequestAccessForContentParams) {
    super('requestAccessForContent', params);
  }
}
